module.exports = __webpack_public_path__ + "media/images/emblems/Blason_de_Sierre_Valais-7abc4b66bf89ed02032d5ea516652933.svg";